import React, { useContext, useState, useEffect, useRef } from 'react'
import * as Yup from 'yup'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import { useFormik } from 'formik'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import BaseActionPage from '@/product/components/species/dynamic/common/BaseActionPage'
import UserContext from '@/product/context/user/userContext'
import ProductContext from '@/product/context/userProduct/productContext'
import '../Tabs/Tabs.css'
import './Role.css'
import { Button, Menu, MenuItem } from '@mui/material'
import CustomDialog from '@/product/components/organisms/Dialog'
import ReportContext from '@/product/context/report/reportContext'
import { useHistory } from 'react-router-dom'
import Loaders from '@/product/components/molecules/Loaders'

const AddBuyer = (props) => {
    const userContext = useContext(UserContext)
    const history = useHistory()

    const {
        single_user,
        getSingleUser,
        userAction,
        responseStatus: responseStatusUser,
    } = userContext
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [buttonData, setButtonData] = useState([])

    const [mapDataValue, setMapDataValue] = useState([])
    const [formikValues, setFormikValues] = useState({})

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])

    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = props.customInitial

        customValidationTemp = {
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            confirm_email:
                data.status === 'new'
                    ? Yup.string()
                          .email('Invalid email format')
                          .oneOf([Yup.ref('email')], "Email's not match")
                          .required('Required!')
                    : Yup.string(),
            phone: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'Only Numbers Are Allowed')
                .required('Required'),
            zip: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'Only numbers are allowed')
                .max(6, 'Maximum 6 characters')
                .min(5, 'Minimum 5 characters')
                .required('Required'),
            ...props.customValidation,
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation, props.customInitial])

    // useEffect(() => {
    //     if (mapDataValueRef.current.length) {
    //         let tempMapData = mapDataValueRef.current
    //         tempMapData.map((mapValue) => {
    //             if (mapValue.name === 'date_closed') {
    //                 mapValue.minDate = dateTimeFormatFunction(
    //                     formikValues.date_added ? formikValues.date_added : null,
    //                 )
    //                 mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
    //                     formikValues.date_added ? formikValues.date_added : null,
    //                 )}`
    //                 mapValue.disablePast = true
    //             } else if (mapValue.name === 'date_added') {
    //                 mapValue.disablePast = true
    //             } else if (mapValue.name === 'sprice') {
    //                 mapValue.disabled = formikValues.auction ? false : true
    //             } else if (mapValue.name === 'rprice') {
    //                 mapValue.disabled = formikValues.auction ? false : true
    //             } else if (mapValue.name === 'bprice') {
    //                 mapValue.disabled = formikValues.buynow ? false : true
    //             }
    //         })
    //         setReload(!reload)
    //         // setMapDataValue(tempMapData)
    //         // setResetMapData(true)
    //     }
    // }, [formikValues])
    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'userAction') {
                if (responseStatusUser.status === 'success') {
                    if (props.function) {
                        props.function(false)
                    }
                }
                setIsLoading(false)
            }
        }
    }, [responseStatusUser])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const submitFunction = () => {
        const value = formikValues
        setIsLoading(true)
        userAction(value)
    }
    const formSubmit = (value, data) => {
        setFormikValues({
            ...formikValues,
            market_status: data,
        })
        submitFunction()
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        props.function(false)
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data.status === 'new') {
            setFormikValues({
                ...formikValues,
                id: 0,
            })
        }
    }, [data])

    useEffect(() => {
        const buttonDataTemp = []
        if (formikValues.id) {
            if (formikValues.market_status === 'draft') {
                buttonDataTemp.push({
                    type: 'button',
                    style: 'secondary',
                    label: 'Save as Draft',
                    additionalValue: 'draft',
                })
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Submit',
                    additionalValue: 'open',
                })
            }
            if (formikValues.market_status === '') {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Update',
                    additionalValue: 'open',
                })
            } else {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Update',
                    additionalValue: 'open',
                })
            }
        } else {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Submit',
                additionalValue: 'open',
            })
        }
        setButtonData(buttonDataTemp)
    }, [formikValues.id, formikValues.market_status])

    return (
        <>
            <CustomDialog
                title="Add User"
                open={props.data.popup}
                function={() => props.function(false)}
                className="userModal"
            >
                {isLoading ? (
                    <Loaders isLoading={isLoading} />
                ) : (
                    <BaseActionPage
                        arrayValue={props.fieldValue}
                        populateValidation={props.populateValidation}
                        data={props.data}
                        additionalFormikUpdate={additionalFormikUpdate}
                        editFunction={getSingleUser}
                        editValue={single_user}
                        handleMapDataValue={handleMapDataValue}
                        actionFunction={formSubmit}
                        cancelFunction={cancelSubmit}
                        buttonAction={buttonData}
                        customValidation={customValidation}
                        customInitialValues={customInitialValues}
                    />
                )}
            </CustomDialog>
        </>
    )
}

export default AddBuyer
